import React, { useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { Link, NavLink } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { RiMenu3Fill } from "react-icons/ri";
function Navbar() {

  const toggle = () => {
    if (window.innerWidth <= 769) {
      setTimeout(() => {
        document.getElementById("NavItems").classList.remove("menu-open");
        document.getElementById("NavItems").classList.add("menu-close");
        setTimeout(() => {
          document.querySelector("#NavItems").style.display = "none";
          setIsActive(!isActive);
        }, 400);
        document.querySelector("body").classList.remove("transparent-body");
      }, 200);
    }
  };

  const toggleDropdown = (className) => {
    if (window.innerWidth <= 769) {
      const allDropdowns = [
        ".NavProgram",
        ".NavCampus",
        ".NavAdministration",
        ".NavAlumni",
        ".NavAdmission",
        ".NavCourseAffiliation",
      ];

      allDropdowns.forEach((dropdown) => {
        const el = document.querySelector(dropdown);
        if (el) {
          if (dropdown === className) {
            el.style.display = el.style.display === "flex" ? "none" : "flex";
          } else {
            el.style.display = "none";
          }
        }
      });
    }
  };

  const [isActive, setIsActive] = useState(true);
  const gotoTop = () => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  const hoverProgram = () => {
    if (window.innerWidth > 769) {
      document.querySelector(".NavProgram").style.display = "flex";
    }
  };
  const hoverOutProgram = () => {
    if (window.innerWidth > 769) {
      document.querySelector(".NavProgram").style.display = "none";
    }
  };
  const hoverCourseAffiliation = () => {
    if (window.innerWidth > 769) {
      document.querySelector(".NavCourseAffiliation").style.display = "flex";
    }
  };
  const hoverOutCourseAffiliation = () => {
    if (window.innerWidth > 769) {
      document.querySelector(".NavCourseAffiliation").style.display = "none";
    }
  };

  const hoverCampus = () => {
    if (window.innerWidth > 769) {
      document.querySelector(".NavCampus").style.display = "flex";
    }
  };
  const hoverOutCampus = () => {
    if (window.innerWidth > 769) {
      document.querySelector(".NavCampus").style.display = "none";
    }
  };
  const hoverAdministration = () => {
    if (window.innerWidth > 769) {
      document.querySelector(".NavAdministration").style.display = "flex";
    }
  };
  const hoverOutAdministration = () => {
    if (window.innerWidth > 769) {
      document.querySelector(".NavAdministration").style.display = "none";
    }
  };
  const hoverAlumni = () => {
    if (window.innerWidth > 769) {
      document.querySelector(".NavAlumni").style.display = "flex";
    }
  };
  const hoverOutAlumni = () => {
    if (window.innerWidth > 769) {
      document.querySelector(".NavAlumni").style.display = "none";
    }
  };
  const hoverAdmission = () => {
    if (window.innerWidth > 769) {
      document.querySelector(".NavAdmission").style.display = "flex";
    }
  };
  const hoverOutAdmission = () => {
    if (window.innerWidth > 769) {
      document.querySelector(".NavAdmission").style.display = "none";
    }
  };

  return (
    <>
      <header>
        <div className="Header">
          <div className="HeaderLeft">
            <div className="vbulogo">
              <Link to="/" onClick={gotoTop}>
                <img src="../Images/vbu_logo.png" alt="vbulogo" />
              </Link>
            </div>
            <div className="HeaderName">
              <h1>University Department of Education</h1>
              <p>Vinoba Bhave University, Hazaribagh</p>
            </div>
            <div className="Menu">
              <span>
                {isActive ? (
                  <RiMenu3Fill
                    size="28px"
                    onClick={() => {
                      document.querySelector("#NavItems").style.display =
                        "flex";
                      document.querySelector("#NavItems").style.backdropFilter =
                        "grayscale(100%)";
                      setIsActive(!isActive);
                      document
                        .querySelector("body")
                        .classList.add("transparent-body");

                      setTimeout(() => {
                        document
                          .getElementById("NavItems")
                          .classList.remove("menu-close");
                        document
                          .getElementById("NavItems")
                          .classList.add("menu-open");
                      }, 10);
                    }}
                  />
                ) : (
                  <RxCross2
                    size="28px"
                    onClick={() => {
                      document
                        .querySelector("body")
                        .classList.remove("transparent-body");

                      document
                        .getElementById("NavItems")
                        .classList.remove("menu-open");
                      document
                        .getElementById("NavItems")
                        .classList.add("menu-close");
                      setTimeout(() => {
                        document.querySelector("#NavItems").style.display =
                          "none";
                        setIsActive(!isActive);
                      }, 400);
                    }}
                  />
                )}
              </span>
            </div>
          </div>
          <div className="HeaderRight">
            {/* <div className="phone-no">
							<div>
								<MdCall className="header-icon" />
							</div>

							<div className="phone-no-desc">
								<span>Phone</span>
								<span>7667479088</span>
							</div>
						</div> */}

            <div className="email-id">
              <div>
                <MdEmail className="header-icon" />
              </div>

              <div className="email-id-desc">
                  <span>Email</span>
                  <a href="mailto:masterofeducationvbu@gmail.com" style={{ display: 'block', color: 'inherit', textDecoration: 'none' }}>masterofeducationvbu@gmail.com</a>
                </div>
            </div>
            <a
              href="https://console.vbueducation.in/"
              target="_blank"
              rel="noopener noreferrer"
              className="login-btn"
            >
              <input type="button" value="Login" name="login" />
            </a>
          </div>
        </div>
      </header>
      <nav id="nav">
        <div className="" id="navbar">
          <div className="NavbarContainer">
            {/* <div className="transparent"> */}
            <ul id="NavItems" className="menu-close">
              <NavLink
                to="/"
                onClick={() => {
                  gotoTop();
                  toggle();
                }}
              >
                <li>
                  {" "}
                  <span>Home</span>
                </li>
              </NavLink>

              <li onMouseOver={hoverCourseAffiliation} onMouseOut={hoverOutCourseAffiliation}>
                <div className="NavItem" onClick={() => toggleDropdown(".NavCourseAffiliation")}>
                  <span>Course Recognition Details</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown />
                  </span>
                </div>

                <div className="NavSubItems">
                  <ul className="NavCourseAffiliation">
                    <NavLink
                      to="/course-affiliation?program=M.Ed."
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>M.Ed.</li>
                    </NavLink>
                    <NavLink
                      to="/course-affiliation?program=Integrated+B.A.+B.Ed+%2F+B.Sc.+B.Ed"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Integrated B.A. B.Ed / B.Sc. B.Ed</li>
                    </NavLink>
                    <NavLink
                      to="/course-affiliation?program=ITEP+(Foundation)"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>ITEP (Foundation)</li>
                    </NavLink>
                  </ul>
                </div>
              </li>

              <li onMouseOver={hoverProgram} onMouseOut={hoverOutProgram}>
                <div className="NavItem" onClick={() => toggleDropdown(".NavProgram")}>
                  <span>Program</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown />
                  </span>
                </div>

                <div className="NavSubItems">
                  <ul className="NavProgram">
                    <NavLink
                      to="/MEd"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>M.Ed.</li>
                    </NavLink>
                    <NavLink
                      to="/BA-BEd"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Integrated B.A. B.Ed / B.Sc. B.Ed</li>
                    </NavLink>
                    <NavLink
                      to="/ITEP"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>ITEP (Foundation)</li>
                    </NavLink>
                  </ul>
                </div>
              </li>

              <li onMouseOver={hoverCampus} onMouseOut={hoverOutCampus}>
                <div className="NavItem" onClick={() => toggleDropdown(".NavCampus")}>
                  <span>Campus</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown />
                  </span>
                </div>

                <div className="NavSubItems ">
                  <ul className="NavCampus">
                    <NavLink
                      to="/library"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Library</li>
                    </NavLink>

                    <NavLink
                      to="/centralLibrary"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Central Library</li>
                    </NavLink>

                    <NavLink
                      to="/ground"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Play Ground</li>
                    </NavLink>

                    {/* <NavLink
                      to="/digitalClass"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Digital Classroom</li>
                    </NavLink> */}

                    <NavLink
                      to="/auditorium"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Auditorium</li>
                    </NavLink>

                    {/* <NavLink
                      to="/gym"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>GYM</li>
                    </NavLink> */}
                    <NavLink
                      to="/solarPower"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Solar Power Campus</li>
                    </NavLink>
                    {/* <NavLink
                      to="/botanicalGarden"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Botanical Garden</li>
                    </NavLink> */}

                    <NavLink
                      to="/park"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Park</li>
                    </NavLink>

                    {/* <NavLink
                      to="/canteen"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Canteen</li>
                    </NavLink> */}
                  </ul>
                </div>
              </li>

              {/* <NavLink
                to="/research"
                onClick={() => {
                  gotoTop();
                  toggle();
                }}
              >
                <li>
                  <span>Research</span>
                </li>
              </NavLink> */}

              <li
                onMouseOver={hoverAdministration}
                onMouseOut={hoverOutAdministration}
              >
                <div className="NavItem" onClick={() => toggleDropdown(".NavAdministration")}>
                  <span>Administration</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown />
                  </span>
                </div>

                <div className="NavSubItems">
                  <ul className="NavAdministration">
                    <NavLink
                      to="/directorMessage"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Head of The Department Message</li>
                    </NavLink>
                    <NavLink
                      to="/teachingMembers"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Faculty Members</li>
                    </NavLink>
                    <NavLink
                      to="/nonTeachingMembers"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Non-Teaching Staff</li>
                    </NavLink>

                  </ul>
                </div>
              </li>

              <li onMouseOver={hoverAlumni} onMouseOut={hoverOutAlumni}>
                <div className="NavItem" onClick={() => toggleDropdown(".NavAlumni")}>
                  <span>Alumni</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown />
                  </span>
                </div>

                <div className="NavSubItems">
                  <ul className="NavAlumni">
                    <NavLink
                      to="/AlumniList"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Alumni List</li>
                    </NavLink>
                    <NavLink
                      to="/alumniForm"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Alumni Form</li>
                    </NavLink>
                  </ul>
                </div>
              </li>

              {/* <NavLink to="/alumniForm"  onClick={()=>{
                      gotoTop() 
                      toggle()
                    }}>
                <li>
                  <span>Alumni</span>
                </li>
              </NavLink> */}

              <NavLink
                to="/gallery"
                onClick={() => {
                  gotoTop();
                  toggle();
                }}
              >
                <li>
                  <span> Gallery </span>
                </li>
              </NavLink>

              <li onMouseOver={hoverAdmission} onMouseOut={hoverOutAdmission}>
                <div className="NavItem" onClick={() => toggleDropdown(".NavAdmission")}>
                  <span>Admission</span>
                  <span className="downArrow">
                    <MdKeyboardArrowDown />
                  </span>
                </div>

                <div className="NavSubItems">
                  <ul className="NavAdmission">
                    <NavLink
                      to="/admissionProcess"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Process</li>
                    </NavLink>
                    <NavLink
                      to="/feeStructure"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Fee Structure</li>
                    </NavLink>
                    <NavLink
                      to="/toppers"
                      onClick={() => {
                        gotoTop();
                        toggle();
                      }}
                    >
                      <li>Toppers</li>
                    </NavLink>
                  </ul>
                </div>
              </li>
              <NavLink
                to="/about"
                onClick={() => {
                  gotoTop();
                  toggle();
                }}
              >
                <li>
                  <span>About</span>
                </li>
              </NavLink>
              <NavLink
                to="/contact"
                onClick={() => {
                  gotoTop();
                  toggle();
                }}
              >
                <li>
                  <span>Contact</span>
                </li>
              </NavLink>

              <a
                href="https://console.vbueducation.in/"
                target="_blank"
                rel="noopener noreferrer"
                className="login-btn-mobile"
              >
                <input type="button" value="Login" name="login" />
              </a>
            </ul>
          </div>
        </div>
        {/* </div> */}
      </nav>
    </>
  );
}

export default Navbar;
